import { z } from "zod/v4";

import { StripeProductVersionList } from "../schemas/stripe";

import { OrgIdNameDtoSchema } from "./organization-name-id";

export const OrganizationAgencyLinkDtoSchema = z.object({
  id: z.uuid(),
  agencyId: z.uuid(),
  name: z.string().nullish(),
  orgId: z.uuid(), // using orgId to avoid organizationId filter
});

export type OrganizationAgencyLinkDto = z.infer<
  typeof OrganizationAgencyLinkDtoSchema
>;

export const CreateOrganizationAgencyLinkDtoSchema =
  OrganizationAgencyLinkDtoSchema.extend({
    id: z.uuid().nullish(),
    shopId: z.string(),
    stripeSubscriptionIds: z
      .object({
        stripeSubscriptionId: z.string(),
        version: z.enum(StripeProductVersionList),
      })
      .array(),
  });

export type CreateOrganizationAgencyLinkDto = z.infer<
  typeof CreateOrganizationAgencyLinkDtoSchema
>;

export const FullOrganizationAgencyLinkDtoSchema =
  OrganizationAgencyLinkDtoSchema.extend({
    organization: OrgIdNameDtoSchema,
  });
export type FullOrganizationAgencyLinkDto = z.infer<
  typeof FullOrganizationAgencyLinkDtoSchema
>;
